import { toast } from "react-toastify";
import { APP_CONFIGURATION_KEYS, BOOLEAN_VALUE, DATE_FORMAT, FILE_EXTENSION, RESPONSE_CODE, VARIABLE } from "./Constant";
import { localStorageItem } from "./modules/utils/LocalStorage";
import moment from "moment";
import { KEY_LOCALSTORAGE } from "./modules/auth/core/_consts";
import { useIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import { KEY, RESPONSE_STATUS_CODE, TYPE } from "./modules/utils/Constant";
import { columnNamesType } from "@oceantech/oceantech-ui";
import { getJsonGenerateForm } from "./modules/services";
import { saveAs } from 'file-saver';
import { getDataFromIndexedDB, openDatabaseByName, saveDataToIndexedDB } from "./modules/utils/IndexedDB";
import { ERROR_MESSAGE, INDEX_DB_NAME, SUCCESS_CODE } from "./modules/constant";
import { COMPONENT_TYPE } from "./modules/component/generate-form/GenerateFormConfig";
import Fuse, { IFuseOptions } from "fuse.js";
import { formatDateDTO, getResponseFileName } from "./modules/utils/FunctionUtils";
import * as Yup from "yup";

export function TranslateMessage(messageId?: string) {
  const intl = useIntl();
  return intl.formatMessage({ id: messageId || "" });
}

export const handleThrowResponseMessage = (res: any) => {
  // todo: Trả ra message theo 2 loại message của response
  const { message, data, code } = res?.data;
  const singleMessageKey = VARIABLE.FUNCTION_CONSTANT.ERROR_MESSAGE;
  const multipleMessageKey = VARIABLE.FUNCTION_CONSTANT.MESSAGE;

  toast.clearWaitingQueue();
  if (handleMessageByResponseCode(code)) {
    return;
  }

  let firstObject = data?.[0];
  if (Object.keys(firstObject).includes(singleMessageKey)) {
    //case:  data = [{errorMessage: "..."}]
    toast.warning(
      firstObject[singleMessageKey] ? firstObject[singleMessageKey] : message //case:  data = [{errorMessage: null}]
    );
  } else if (Object.keys(firstObject).includes(multipleMessageKey)) {
    data.forEach((x: any) => {
      toast.warning(x.field + ": " + x[multipleMessageKey]);
    });
  } else {
    toast.error("GENERAL.ERROR");
  }
};

const handleMessageByResponseCode = (code?: number) => {
  switch (code) {
    case RESPONSE_CODE.FORBIDDEN:
      toast.warning(TranslateMessage("TOAST.ERROR.FORBIDDEN"));
      return true;
    case RESPONSE_CODE.METHOD_NOT_ALLOWED:
      toast.warning(TranslateMessage("TOAST.ERROR.METHOD_NOT_ALLOWED"));
      return true;
    case RESPONSE_CODE.CONFLICT:
      toast.warning(TranslateMessage("TOAST.ERROR.CONFLICT"));
      return true;
    default:
      return false;
  }
}

export const getCurrentUserInformation = () => {
  let currentUser = localStorageItem.get(KEY_LOCALSTORAGE.CURRENT_USER);

  return {
    currentUser: currentUser ? currentUser : {},
  }
}

export const formatDateTable = (date: any) => {
  let newDate = new Date(date);
  return date && moment(newDate).isValid() ? moment(date).format(DATE_FORMAT.TABLE) : null;
};

export const isSuccessfulResponse = (code: number) => RESPONSE_CODE.SUCCESS === code;

export const isEven = (number: number) => number % 2 === 0;

export const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, callBack: () => void) => {
  if (KEY.ENTER === event.key) {
    callBack()
  }
}

export const flatArrayByChildrenName = (arr: any, childName: string) => {
  let result: any = [];
  if (!arr) {
    return result;
  }
  arr.forEach((item: any) => {
    result.push(item);
    if (item[childName] && item[childName].length > 0) {
      result = result.concat(flatArrayByChildrenName(item[childName], childName));
    }
  });

  return result;
}

export const getColumnsAlignByType = (column: columnNamesType) => {
  switch (column.type) {
    case TYPE.DATE:
      return "center";
    case TYPE.NUMBER:
      return "center";
    case TYPE.MONEY:
      return "right";
    case TYPE.TEXT:
      return "left";
    default:
      return "left";
  }
}

export const handleKeyUp = (event: React.ChangeEvent<HTMLInputElement>, callBack: () => void) => {
  if (!event.target.value) {
    callBack()
  }
}

export const generateForm = async (codeAPI: string, setIsLoading?: any, pathUrl?: string) => {
  try {
    setIsLoading && setIsLoading(true);
    const { data } = await getJsonGenerateForm(codeAPI, pathUrl);
    if (RESPONSE_CODE.SUCCESS === data?.code) {
      return JSON.parse(data?.data);
    } else {
      toast.error("Có lỗi xảy ra, vui lòng thử lại!");
    }
  } catch (error) {
    toast.error("Có lỗi xảy ra, vui lòng thử lại!");
  } finally {
    setIsLoading && setIsLoading(false);
  }
};

export const functionExportToExcel = async (
  apiFunction: (params?: any) => Promise<any>,
  searchObject: any,
  fileName?: string,
  setPageLoading = (isLoading: boolean) => { }
) => {
  try {
    setPageLoading(true);
    const response: any = await apiFunction(searchObject);

    if (
      !isSuccessfulResponse(response?.status) ||
      response?.data?.code >= RESPONSE_STATUS_CODE.BAD_REQUEST
    ) {
      toast.error('Có lỗi xảy ra, vui lòng thử lại!');
      return;
    }

    const file = new Blob([response.data], {
      type: FILE_EXTENSION.EXCEL,
    });
    const responseFileName = getResponseFileName(response.headers);
    saveAs(file, responseFileName || fileName);
  } catch (error) {
    console.error(error);
    toast.error("Có lỗi xảy ra, vui lòng thử lại!");
  } finally {
    setPageLoading(false);
  }
};

export const formatStringDateDTO = (date: string | Date | undefined) => {
  return date ? moment(date).format("YYYY-MM-DDTHH:mm:ss") : "";
};

export const generateDataByUrl = async (
  codeAPI: string,
  funcApi: () => Promise<any>,
  setIsLoading?: (isLoading: boolean) => void
) => {
  setIsLoading && setIsLoading(true);
  try {
    const db = await openDatabaseByName(INDEX_DB_NAME.URL_DATA);
    let dataFieldAuto = await getDataFromIndexedDB(db, codeAPI, INDEX_DB_NAME.URL_DATA);

    if (dataFieldAuto) {
      return JSON.parse(dataFieldAuto) || {};
    } else {
      const res = await funcApi();
      if (res?.data?.code === SUCCESS_CODE) {
        const dataToStore = res.data.data;

        if (dataToStore) {
          await saveDataToIndexedDB(db, codeAPI, JSON.stringify(res), INDEX_DB_NAME.URL_DATA);
          return res;
        } else {
          toast.error(ERROR_MESSAGE);
          return {};
        }
      } else {
        toast.error(ERROR_MESSAGE);
      }
    }
  } catch (error) {
    console.error("Error:", error);
    toast.error(ERROR_MESSAGE);
  } finally {
    setIsLoading && setIsLoading(false);
  }
};

export const useDebounce = <T,>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export const generateSearchParams = (data: any, formCode?: string) => {
  const handleValues = () => {
    let searchParams: any = {};

    const checkValue = (lstData: any) => {
      let newLstData = lstData?.components?.filter(
        (item: any) => item.type !== COMPONENT_TYPE.BUTTON
      );
      newLstData?.forEach((data: any) => {
        switch (data.type) {
          case COMPONENT_TYPE.SELECT:
            if (data?.data?.headers?.length) {
              let ListKeySearch = {};
              data?.data?.headers?.length && data?.data?.headers.map((item: any, index: any) => {
                ListKeySearch = {
                  ...ListKeySearch,
                  [item.key]: item.value || ""
                }
              })
              searchParams = {
                ...searchParams,
                [data?.key]: ListKeySearch
              };
            }
            break;
          case COMPONENT_TYPE.COLUMNS:
            data?.columns?.forEach((lstData: any) => {
              checkValue(lstData);
            });
            break
          default:
            break;
        };
      });
    };

    checkValue(data);
    return formCode ? { [formCode]: searchParams } : searchParams;
  };

  return handleValues();
};

export const formatMoney = (value: number) => {
  if (!value) {
    return 0;
  } else {
    let result = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return result;
  }
};

export const handleSearchByFuse = (listData: any[], textSearch: string, setListData: (data: any) => void,
  extraOptions?: IFuseOptions<any>) => {
  const fuseOptions = {
    isCaseSensitive: false, //phân biệt chữ hoa chữ thường
    includeScore: true,
    shouldSort: true,
    includeMatches: false,
    findAllMatches: false,
    minMatchCharLength: 2, //kết quả trả về cả những phần tử khớp theo số lượng ký tự truyền vào
    // location: 0,
    // threshold: 1,
    // distance: 100,
    useExtendedSearch: true, //search nâng cao, phụ thuộc các dấu =, ", '
    ignoreLocation: true,
    ignoreFieldNorm: true,
    fieldNormWeight: 1,
    keys: ["code", "name"],
    ...extraOptions
  };

  const fuse = new Fuse(listData, fuseOptions);
  if (textSearch !== "") {
    const lstServices = fuse.search(textSearch).map((ser: any) => {
      return ser?.item;
    });
    setListData(lstServices);
  } else {
    setListData(listData);
  }
}

export const generateInitValues = (data: any) => {
  const handleValues = () => {
    let values: any = {};

    const checkValue = (lstData: any) => {
      let newLstData = lstData?.components?.filter(
        (item: any) => item.type !== COMPONENT_TYPE.BUTTON
      );
      newLstData?.forEach((data: any) => {
        switch (data.type) {
          case COMPONENT_TYPE.TEXTFIELD:
          case COMPONENT_TYPE.DATEPICKER:
          case COMPONENT_TYPE.TEXTAREA:
          case COMPONENT_TYPE.DAY:
          case COMPONENT_TYPE.TIME:
          case COMPONENT_TYPE.EMAIL:
          case COMPONENT_TYPE.PHONE:
            values[data.key] = data.defaultValue;
            break;
          case COMPONENT_TYPE.DATETIME:
            values[data.key] = data.defaultDate === "newDate" ? formatDateDTO(new Date()) : data.defaultDate;
            break;
          case COMPONENT_TYPE.NUMBER:
            values[data.key] = parseFloat(data.defaultValue) || '';
            break;
          case COMPONENT_TYPE.SELECT:
            try {
                const fieldValue = data.defaultValue && typeof data.defaultValue !== "object"
                ? JSON.parse(data.defaultValue)
                : {
                  [data.key]: "",
                  [`${data.key}Id`]: "",
                  [`${data.key}Name`]: "",
                };

                values = {
                  ...values,
                  ...fieldValue,
                };
            } catch (error) {
              console.error(error);
            }
            break;
          case COMPONENT_TYPE.CHECKBOX:
            values[data.key] = convertBooleanToFormValue(data.defaultValue);
            break;
          case COMPONENT_TYPE.RADIO:
            values[data.key] = data.defaultValue == "true" ? "1" : "0";
            break;
          case COMPONENT_TYPE.COLUMNS:
            data?.columns?.forEach((lstData: any) => {
              checkValue(lstData);
            });
            break
          default:
            break;
        };
      });
    };

    checkValue(data);

    return values;
  };

  return handleValues();
};

export const generateValidationSchema = (data: any, formCode: string) => {
  const handleValidate = () => {
    let objValidation: any = {};
    const checkValidate = (lstData: any) => {
      let newLstData = lstData?.components?.filter(
        (item: any) => item.type !== COMPONENT_TYPE.BUTTON
      );

      newLstData?.forEach((value: any) => {
        if (value.validate?.required) {
          objValidation[value.key] = Yup.string()
            .required('Bắt buộc nhập')
            .nullable();
        } else if (value?.type === COMPONENT_TYPE.COLUMNS && value?.columns && value?.columns?.length) {
          value?.columns?.forEach((lstValue: any) => {
            checkValidate(lstValue);
          });
        }
      });
    };
    checkValidate(data);
    return Yup.object({
      [formCode]: Yup.object(objValidation),
    });
  };

  return handleValidate();
};

export const getConfigUrl = (key: string) =>
  localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[key] ?? '';

export const getAppUrlConfigurationOptions = () => {
  const configuration = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION);

  if (!configuration) return [];

  const categories: string[] = configuration.isCategory ?? [];
  const options: any[] = [];

  Object.keys(configuration).forEach((key) => {
    if (categories.includes(key)) {
      options.push({
        url: configuration[key],
        name: configuration[`${key}Name`] || configuration[`${key}_name`] || '',
      });
    }
  });

  return options;
};

export const convertBooleanToFormValue = (value: boolean) => {
  return value ? BOOLEAN_VALUE.TRUE : BOOLEAN_VALUE.FALSE;
};